var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharacterEvilHalloweenHorrorMonsterSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "5 5 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#e5936b;}.cls-2{fill:#e17c46;}.cls-3{fill:#efc89d;}.cls-4{fill:#748a95;}.cls-5{fill:#dd5891;}.cls-6{fill:#ebb87f;}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Evil Tree",
    id: "Evil_Tree"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.71,32.93l-7-6.11a1.06,1.06,0,0,1-.35-.92l.35-2.81a.43.43,0,0,1,.48-.38l.11,0,2.66,1a.5.5,0,0,0,.65-.29.48.48,0,0,0,0-.37L16.13,22a1,1,0,0,1,.15-1l.76-.94a.46.46,0,0,1,.65-.07s0,0,.06,0L20.33,23l2.2,5Z",
    id: "path70493-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.05,26.54a1,1,0,0,0-.69.31,1,1,0,0,0,0,1.41h0L21,31.75a1,1,0,0,0,1.42,0h0a1,1,0,0,0,0-1.41h0l-3.65-3.48A1,1,0,0,0,18.05,26.54Z",
    id: "path258862"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.69,32.74,47,29.11a1.11,1.11,0,0,1,1.28-.1l1,.61a.76.76,0,0,1,.25,1v0l-1.06,1.59a.32.32,0,0,0,.09.45.31.31,0,0,0,.25.05l1.65-.31a.74.74,0,0,1,.88.59v0l.28,2a1.25,1.25,0,0,1-.54,1.22l-7.86,5.23-2.79-4.39Z",
    id: "path70916-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.57,46.87,41.24,9.48A1.48,1.48,0,0,0,39.76,8h-.42a2.06,2.06,0,0,0-2,1.4,1,1,0,0,1-1.78,0v0A2.12,2.12,0,0,0,33.6,8h-5a1.3,1.3,0,0,0-1.29,1.47A7.74,7.74,0,0,1,27,12.78l-.28.86a.94.94,0,0,1-1.83-.19l-.45-4A1.65,1.65,0,0,0,22.8,8h-.15a1.48,1.48,0,0,0-1.48,1.48L18.84,46.87l12.36,3.9Z",
    id: "rect67555-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.32,29.7a.47.47,0,0,0-.22.07,14.69,14.69,0,0,1-6.89,1.63,14.71,14.71,0,0,1-6.9-1.63h0a.48.48,0,0,0-.45,0h0a.45.45,0,0,0-.23.39,7.58,7.58,0,0,0,15.15,0,.46.46,0,0,0-.38-.44Z",
    id: "path67713"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.21,21.6a.43.43,0,0,0-.22.06l-5.38,3.11a.46.46,0,0,0-.17.61h0a3.55,3.55,0,1,0,6.16-3.55h0A.45.45,0,0,0,38.21,21.6Z",
    id: "path67711"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.2,21.6a.44.44,0,0,0-.39.23A3.55,3.55,0,1,0,30,25.38h0a.46.46,0,0,0-.17-.61h0l-5.38-3.11A.46.46,0,0,0,24.2,21.6Z",
    id: "path71348-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.45,32.13l-2.22,1.65a1,1,0,0,0-.2,1.39h0a1,1,0,0,0,1.4.2h0l2.21-1.64a1,1,0,0,0,.21-1.4h0A1,1,0,0,0,47.45,32.13Z",
    id: "path71088"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.6,12.05a1,1,0,0,0-1,1h0l.07,4.55a1,1,0,0,0,2,0h0L37.61,13a1,1,0,0,0-1-1Z",
    id: "path72823"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.48,40a1,1,0,0,0-1,1h0l0,5.89a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1h0l0-5.89A1,1,0,0,0,36.48,40Z",
    id: "path72938"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.61,37.25a1,1,0,0,0-1,1h0l0,4.75a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1h0l0-4.75a1,1,0,0,0-1-1Z",
    id: "path73053"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29,16.38a1,1,0,0,0-1,1v3.06a1,1,0,0,0,2,0V17.38A1,1,0,0,0,29,16.38Z",
    id: "path73715"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.72,54v-1.2a5.9,5.9,0,0,1,5.91-5.91H43.78a5.9,5.9,0,0,1,5.91,5.91V54a2,2,0,0,1-2,2H14.74A2,2,0,0,1,12.72,54Z",
    id: "rect64865-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterEvilHalloweenHorrorMonsterSvgrepoCom);
export default __webpack_public_path__ + "static/media/character-evil-halloween-horror-monster-svgrepo-com.96b4f811b5eb55e6ba86cd452eed74c1.svg";
export { ForwardRef as ReactComponent };